module.exports = "/img/logo-basket.png?f8df87722f33602cac5e2a04bfa44030";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo-basket.png
// module id = Tu4w
// module chunks = 66